var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { util } from '@joint/plus';
import { RectPrism, RectPrismView } from './rect-prism';
var TYPE = 'yamazumi.BottomElement';
var BottomElement = /** @class */ (function (_super) {
    __extends(BottomElement, _super);
    function BottomElement(attributes, options) {
        var _this = this;
        attributes.label = '';
        _this = _super.call(this, attributes, options) || this;
        var operators = attributes.operators, operationGap = attributes.operationGap, taskWidth = attributes.taskWidth, depth = attributes.depth;
        var width = (operators.length * taskWidth) + operationGap;
        _this.prop({
            size: {
                width: width,
                height: 30
            },
            attrs: {
                side: {
                    d: "M calc(w) 0 l ".concat(depth + RectPrism.bottomMargin, " -").concat(depth + RectPrism.bottomMargin, " v calc(h-").concat(RectPrism.bottomMargin, ") l -").concat(depth + RectPrism.bottomMargin, " ").concat(depth + RectPrism.bottomMargin, " z")
                },
                top: {
                    d: "M 0 0 l ".concat(depth + RectPrism.bottomMargin, " -").concat(depth + RectPrism.bottomMargin, " h calc(w) l -").concat(depth + RectPrism.bottomMargin, " ").concat(depth + RectPrism.bottomMargin, " z")
                }
            }
        });
        operators.forEach(function (operator, i) {
            var _a;
            var x = i * taskWidth + i * operationGap + taskWidth / 2;
            (_a = _this.markup).push.apply(_a, util.svg /* xml */(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                <text\n                    @selector=\"label", "\"\n                    text-anchor=\"middle\"\n                    x=\"", "\"\n                    y=\"18\"\n                    font-family=\"Noto Sans\"\n                    stroke=\"none\"\n                    fill=\"#4B5563\"\n                    font-size=\"12\"\n                    font-weight=\"600\"\n                >\n                    ", "\n                </text>\n            "], [/* xml */ "\n                <text\n                    @selector=\"label", "\"\n                    text-anchor=\"middle\"\n                    x=\"", "\"\n                    y=\"18\"\n                    font-family=\"Noto Sans\"\n                    stroke=\"none\"\n                    fill=\"#4B5563\"\n                    font-size=\"12\"\n                    font-weight=\"600\"\n                >\n                    ", "\n                </text>\n            "])), i + 1, x, operator.label));
        });
        return _this;
    }
    BottomElement.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults.call(this)), { type: TYPE, z: -1 });
    };
    return BottomElement;
}(RectPrism));
export { BottomElement };
var BottomElementView = /** @class */ (function (_super) {
    __extends(BottomElementView, _super);
    function BottomElementView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BottomElementView;
}(RectPrismView));
export { BottomElementView };
var templateObject_1;
